import { lazy } from "react";
import ErrorBoundary from "@/hoc/ErrorBoundary/ErrorBoundary.jsx";

const AboutUs = lazy(() => import("./AboutUs"));

export const aboutUsRoute = {
  path: "aboutUs",
  element: <AboutUs />,
  errorElement: <ErrorBoundary />
};
